<script>
  import { RadioButton } from 'element-ui'
  export default {
    name:'ElRadioButton',
    extends:RadioButton
  }
</script>
